module.exports = __webpack_public_path__ + "static/img/news_top_05_1.70703a09.gif";